<template>
  <div>
    <div id="dContentdetalis">
      <div id="cNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;
        <router-link tag="span" :to="{path:'/Social/flowmuseum'}">最新活动</router-link>
        <!--&nbsp;&nbsp;>>&nbsp;&nbsp;<span style="clear: both;">{{ tableData.title }}</span>-->
        <span v-if="tableData.wState===1">
          <router-link tag="span" :to="{path:'/Social/flowmuseum', query:{id:tableData.id,title:tableData.title}}">去报名</router-link>
        </span>
      </div>
      <div class="d-content">
        <div>{{ tableData.title }}</div>
        <div v-if="tableData.videotype=='102'" >
          <el-row :gutter="15" class="d-video">
            <el-col style="width: 70%;">
                <video id="myVideo" class="video-js" tabindex="2" mediatype="video" loop="loop" controls="controls" preload="auto" :src="tableData.video"
                  style="width: 100%;"></video>
            </el-col>
          </el-row>
        </div>
        <div id="contents" v-html="tableData.contents"></div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
    <div id="mdContentdetalis">
      <div id="mcNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;
        <router-link tag="span" :to="{path:'/Social/flowmuseum'}">最新活动</router-link>
        <span v-if="mtableData.wState===1">
          <router-link tag="span" :to="{path:'/Social/flowmuseum', query:{id:mtableData.id,title:mtableData.title}}">去报名</router-link>
        </span>
      </div>
      <div class="d-content">
        <div>{{ mtableData.title }}</div>
        <div v-if="tableData.videotype=='102'" >
          <el-row :gutter="15" class="d-video">
            <el-col style="width: 70%;">
                <video id="myVideo" class="video-js" tabindex="2" mediatype="video" loop="loop" controls="controls" preload="auto" :src="tableData.video"
                  style="width: 100%;"></video>
            </el-col>
          </el-row>
        </div>
        <div id="mcontents" v-html="mtableData.contents"></div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        clientHeight: '',
        tableData: [],
        infoid: '',
        loading: false,
        title: '',
        mtableData: [],
        config: {
          url: location.href.split("&t=")[0],
          source: "",
          title: decodeURIComponent(this.$route.query.t),
          description: "",
          image: "",
          weiboKey: "",
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
          wechatQrcodeSize: 100,
          sites: ["weibo", "qq", "wechat"],
          mobileSites: [],
          disabled: [],
          initialized: !1
        }
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("dContentdetalis").style.display = "none";
        this.mhandleSearch();
      } else {
        document.getElementById("mdContentdetalis").style.display = "none";
        document.getElementById("dContentdetalis").style.display = "block";
        this.handleSearch();
      }
      this.handleSearch();
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        this.loading = true;
        this.infoid = this.$route.query.id;
        let url = this.HOST + '/api/v1/activity/activityOne/' + this.infoid + '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title;
          if (cData && cData.data) {
            that.tableData = cData.data;
            let timestampEnd = parseInt(that.tableData.activityendtime);
            let timestampstart = parseInt(that.tableData.activitytime);
            that.tableData.starttime = moment(activitytime).format("YYYY-MM-DD");
            that.tableData.endtime = moment(timestampEnd).format("YYYY-MM-DD");
            var newtime = (new Date()).toLocaleDateString();
            newtime = newtime.replace(/\//g, '-');
            var nowdate = (new Date(newtime));
            if (nowdate < timestampstart) {
              that.tableData[i].wState = 1;
            } else if (nowdate >= timestampstart && nowdate <= timestampEnd) {
              that.tableData[i].wState = 2;
            } else if (nowdate > timestampEnd) {
              that.tableData[i].wState = 0;
            }
          }
        }).catch(function(error) {
          console.log(err);
        })
      },
      mhandleSearch() {
        this.msearch();
      },
      // 查询列表
      msearch: function() {
        let that = this;
        this.loading = true;
        this.infoid = this.$route.query.id;
        let url = this.HOST + '/api/v1/activity/activityOne/' + this.infoid + '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title;
          if (cData && cData.data) {
            that.mtableData = cData.data;
            let timestampEnd = parseInt(that.mtableData.activityendtime);
            let timestampstart = parseInt(that.mtableData.activitytime);
            that.mtableData.starttime = moment(activitytime).format("YYYY-MM-DD");
            that.mtableData.endtime = moment(timestampEnd).format("YYYY-MM-DD");
            var newtime = (new Date()).toLocaleDateString();
            newtime = newtime.replace(/\//g, '-');
            var nowdate = (new Date(newtime));
            if (nowdate < timestampstart) {
              that.mtableData[i].wState = 1;
            } else if (nowdate >= timestampstart && nowdate <= timestampEnd) {
              that.mtableData[i].wState = 2;
            } else if (nowdate > timestampEnd) {
              that.mtableData[i].wState = 0;
            }
          }
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #dContentdetalis {
    display: none;
    width: 70%;
    margin-right: 15%;
    margin-left: 15%;
    height: 100%;
  }

  #dContentdetalis>#cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #cNav>span:nth-child(1),
  #cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #cNav>span:nth-child(3) {
    cursor: pointer;
    color: #FF5500;
    margin-left: 20px;
  }

  #cNav>span:nth-child(3):hover {
    color: #FF9900;
  }

  #cNav>span:nth-child(1):hover,
  #cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #dContentdetalis>div:nth-child(2)>div:nth-child(1) {
    line-height: 40px;
    font-size: 1.5em;
    font-weight: 800;
  }

  #dContentdetalis>div:nth-child(2)>div:nth-child(2) {
    text-align: left;
    line-height: 30px;
  }

  #mdContentdetalis {
    height: 100%;
    margin: auto 20px;
  }

  #mdContentdetalis>#mcNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #mcNav>span:nth-child(1),
  #mcNav>span:nth-child(2) {
    cursor: pointer;
  }

  #mcNav>span:nth-child(3) {
    cursor: pointer;
    color: #mFF5500;
    margin-left: 20px;
  }

  #mcNav>span:nth-child(3):hover {
    color: #mFF9900;
  }

  #mcNav>span:nth-child(1):hover,
  #mcNav>span:nth-child(2):hover {
    color: #mFF9900;
  }

  #mdContentdetalis>div:nth-child(2)>div:nth-child(1) {
    line-height: 40px;
    font-size: 1.5em;
    font-weight: 800;
  }

  #mdContentdetalis>div:nth-child(2)>div:nth-child(2) {
    text-align: left;
    line-height: 30px;
  }

  .d-content>div<:nth-child(1) {
    font-size: 20px;
    font-weight: bold;
    line-height: 2.5rem;
  }

  .d-content>div<:nth-child(2) {
    font-size: 16px;
    line-height: 1.875rem;
  }
  .d-video {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 30px 0;
  }
  
  .nav-video {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Social/flowmuseumDetials.vue